import React from 'react';
import { Typography, withStyles, CircularProgress, Tabs, Tab } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { getLeague } from '../../data/leagues';
import { withRouter } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link } from 'react-router-dom';
import { AddTeam } from './add-team';
import SubsImproved from '../ipl/subs-improved';
import AuctionAllTeams from '../ipl/auction-all-teams';
import Captains from '../ipl/captains';
import { CreateLeague } from './create-league';

const useStyles = (theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1,
        marginBottom: theme.spacing(10),
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    container: {
        maxWidth: 800,
    },
    header: {
        flexBasis: '100%',
    },
    content: {
        textAlign: 'left',
    }
});

class ViewLeagueDetailsInternal extends React.Component {
    constructor(props) {
        super(props);
        this.leagueID = this.props.match.params.leagueID;
        this.state = {
            loading: true,
            serverError: undefined,
            league: undefined,
            tabIndex: 0,
        };
        this.handleTabChange = this.handleTabChange.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.refresh = this.refresh.bind(this);
    }

    async refresh() {
        try {
            const league = await getLeague(this.leagueID);
            this.setState(() => ({
                ...this.state,
                loading: false,
                league: league,
            }));
        } catch (err) {
            this.setState(() => ({
                ...this.state,
                loading: false,
                serverError: err.message,
            }));
        }
    }

    async componentDidMount() {
        this.refresh();
    }

    handleTabChange(event, newTabIndex) {
        this.setState(() => ({
            ...this.state,
            tabIndex: newTabIndex,
        }));
    }

    render() {
        let { classes, type } = this.props;
        const isAdmin = type === 'admin';
        const spinner = this.state.loading ? <div style={{ 'flexBasis': '100%' }}><CircularProgress /></div> : '';
        const subsHeader = this.state.league === undefined ? undefined : (this.state.league.waivers ? 'SUBS' : 'PLAYING XI');

        return (
            <div className={classes.root}>
                <div className={classes.container}>
                    {this.state.league !== undefined &&
                        <Link to={`/leagues/${this.state.league.leagueID}`} >
                            <ArrowBackIcon style={{ float: 'left' }} />
                        </Link>
                    }
                    <Typography variant="h5" className={classes.header}>
                        {isAdmin ? 'League Admin' : 'League Settings'}
                    </Typography>
                    {this.state.league !== undefined &&
                        <Typography variant="h6" className={classes.header}>
                            {this.state.league.name}
                        </Typography>
                    }
                    {spinner}
                    {this.state.serverError !== undefined &&
                        <Alert severity="error">
                            <AlertTitle>Server error</AlertTitle>
                            {this.state.serverError}
                        </Alert>
                    }
                    {this.state.league !== undefined &&
                        <div className={classes.content}>
                            {isAdmin ? (
                                <>
                                    <Tabs value={this.state.tabIndex} onChange={this.handleTabChange} style={{ marginBottom: 30, flexWrap: 'wrap' }}>
                                        <Tab label="Captains" />
                                        <Tab label={subsHeader} />
                                        <Tab label="Set Squad" />
                                    </Tabs>
                                    {this.state.tabIndex === 0 && <Captains />}
                                    {this.state.tabIndex === 1 && (this.state.league.waivers ? <SubsImproved embedded /> : <AuctionAllTeams embedded />)}
                                    {this.state.tabIndex === 2 && <AddTeam league={this.state.league} />}
                                </>
                            ) : (
                                <CreateLeague league={this.state.league} />
                            )}
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export const ViewLeagueDetails = withRouter(withStyles(useStyles)(ViewLeagueDetailsInternal));
